import { useModalHook } from '@/components/commons/modals/useModalHook';
import { detectEnvUtils } from '@/shared/util/detectEnvUtils';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { getSipConnectionInfo } from '../sipApi/sipApi';
import { closeSipClient, initializeSipClient } from './sipService';
import { callStatusRecoil } from '../sip-recoil/sipRecoil';
import { useRecoilValue } from 'recoil';
import { connectSipRecoil } from '@/recoil/atoms/MobileRecoil/MobileRecoil';

interface IUseSipClient {
  setSipStatus: React.Dispatch<React.SetStateAction<'connected' | 'disconnected' | null>>;
  setIncomingCallInfo: React.Dispatch<React.SetStateAction<{ caller: string } | null>>;
  setCallStatus: React.Dispatch<React.SetStateAction<'idle' | 'dialing' | 'connected' | 'ended' | 'ringing'>>;
}

const useSipClient = ({ setSipStatus, setIncomingCallInfo, setCallStatus }: IUseSipClient) => {
  const [micAccess, setMicAccess] = useState(false); // 마이크 권한 위한 STATE
  const callStatus = useRecoilValue(callStatusRecoil);

  // TODO - SD ==========>
  const connectSipS = useRecoilValue(connectSipRecoil);
  // TODO - SD <==========

  const { data, isLoading, isError } = useQuery(['/sip/connection-info'], getSipConnectionInfo, {
    enabled: micAccess && connectSipS,
  });

  const { warningModal } = useModalHook();

  const start = (data: any) => {
    initializeSipClient(data, setSipStatus, setIncomingCallInfo, setCallStatus, callStatus);
  };

  useEffect(() => {
    // SIP 클라이언트 초기화
    if (data && !isLoading && !isError) {
      start(data);
    }

    // 컴포넌트가 unmount 될 때 SIP 클라이언트 종료
    return () => {
      closeSipClient();
    };
  }, [data, isLoading, isError]);

  useEffect(() => {
    const environmentApp = detectEnvUtils();
    if (environmentApp === 'app') {
      // TODO - SD : test
      window.call_audio_record();
      // warningModal('알림', '현재 웹에서 사용 가능하며, 다음 버전부터 이용 가능합니다.', true);
    } else {
      setMicAccess(true); // 마이크 허용
    }
  }, []);

  window.getAppPermissionStatus = (permissionStatus, os) => {
    if (permissionStatus === 'true') {
      setMicAccess(true); // 마이크 허용
    } else {
      warningModal('주의', '앱의 마이크 권한을 확인 후 다시 실행해 주세요.', true);
    }
  };

  return {
    start,
    stop: closeSipClient,
  };
};

export default useSipClient;
